<template>
  <!-- 部屋マスタ設定画面 -->
  <v-dialog v-model="dialog" persistent max-width="520px">
    <v-container>
      <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="InsertTitle">
            <v-toolbar color="primary" dark>部屋マスタ設定</v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="11"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <ryou-input
                  label="部屋番号"
                  v-model="model.room_id"
                  :value="model.room_id"
                  :maxlength="10"
                  :rules="inputRulesTen"
                  :disabled="roomUpdateFlg"
                >
                </ryou-input>
              </v-col>
              <v-col cols="5" class="headerTitle">
                <ryou-select
                  :items="siyouItems"
                  :label="'使用状況'"
                  :itemText="'code_text'"
                  :itemValue="'code_value'"
                  v-model="selectSiyou"
                  :value="selectSiyou"
                  :rules="siyouRules"
                >
                </ryou-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <ryou-input
                  label="部屋別調整代"
                  v-model="model.unit_price"
                  :value="model.unit_price"
                  :maxlength="6"
                  :rules="[GlobalRules.number]"
                >
                </ryou-input>
              </v-col>
              <v-col cols="5">
                <ryou-select
                  :items="roomClassItems"
                  :label="'部屋種類'"
                  :itemText="'code_text'"
                  :rules="[GlobalRules.required]"
                  :itemValue="'code_value'"
                  v-model="selectRoomClass"
                  :value="selectRoomClass"
                >
                </ryou-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <ryou-input
                  label="階数"
                  v-model="model.floor"
                  :value="model.floor"
                  :maxlength="2"
                  :rules="inputRulesTwo"
                >
                </ryou-input>
              </v-col>
              <v-col cols="5" class="headerTitle">
                <ryou-select
                  :items="sexItems"
                  :label="'性別'"
                  :itemText="'code_text'"
                  :itemValue="'code_value'"
                  v-model="selectSex"
                  :value="selectSex"
                  :rules="sexRules"
                >
                </ryou-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="11"> </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions style="padding-bottom: 20px">
            <v-row>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="5">
                <ryou-black-btn
                  :label="'閉じる'"
                  :handlerClick="handleCancel"
                  :iconCls="'mdi-close'"
                >
                </ryou-black-btn>
              </v-col>
              <v-col cols="2">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="4">
                <ryou-black-btn
                  :label="'更新'"
                  :handlerClick="handleOk"
                ></ryou-black-btn>
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5"> </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </v-dialog>
</template>

<script>
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

export default {
  name: "MasterRoomProvideDialog",
  components: {
    RyouSelect,
    RyouInput,
    RyouBlackBtn,
    RyouConfirm,
  },
  mounted() {
    this.inputRulesTwo.push(this.GlobalRules.required);
    //this.inputRulesTwo.push(this.GlobalRules.counter_2);
    this.inputRulesTwo.push(this.GlobalRules.numbercuurency);
    // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） start
    this.inputRulesTen.push(this.GlobalRules.required);
    this.inputRulesTen.push(this.GlobalRules.counter_10);
    this.inputRulesTen.push(this.GlobalRules.hanAlphahyphen);
    // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） end
    this.sexRules.push(this.GlobalRules.required);
    this.siyouRules.push(this.GlobalRules.required);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
    buildingId: "",
    roomClass: "",
    roomUpdateFlg: true,
    valid: true,
    inputRulesTwo: [],
    inputRulesTen: [],
    sexRules: [],
    siyouRules: [],
    selectSiyou: "",
    selectSex: "",
    selectRoomClass: "",
    siyouItems: [],
    sexItems: [],
    roomClassItems: [],
    model: {
      building_id: "",
      room_class: "",
      room_id: "",
      floor: "",
      unit_price: "",
    },
  }),
  created() {
    this.initData();
    if (this.loadFlag == true) {
      this.selectedData();
    }
  },
  methods: {
    add(buildingId) {
      this.open();
      this.model.building_id = buildingId;
      this.roomUpdateFlg = false;
      this.title = "部屋マスタ新規";
    },
    edit(record) {
      this.open();
      this.title = "部屋マスタ編集";
      this.roomUpdateFlg = true;
      setTimeout(() => {
        this.model = Object.assign({}, record);
      }, 10);
      this.selectSex = record.sex;
      this.selectSiyou = record.use_status;
      this.selectRoomClass = record.room_class;
    },
    initData() {
      this.getRequest(
        "/masterRoom/selectListGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.siyouItems = data.result[0].children; //使用状況
          this.siyouItems.push(this.selectSiyou);
          this.sexItems = data.result[1].children; //性別
          this.sexItems.push(this.selectSex);
        }
      });
      this.getRequest(
        "/masterRoom/roomKindGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.roomClassItems = data.result[0].children; //部屋種類
        }
      });
      setTimeout(() => {}, 100);
    },
    handleOk() {
      var valid = this.$refs.p1DialogForm.validate();
      if (valid) {
        var that = this;
        if (this.roomUpdateFlg) {
          this.$refs.confirm
            .open("更新", "部屋マスタを更新します。宜しいですか？", {
              color: "info",
            })
            .then((confirm) => {
              if (confirm) {
                let params = {
                  user_id: this.$store.getters.getUserId,
                  building_id: this.model.building_id,
                  room_id: this.model.room_id,
                  room_class: this.selectRoomClass,
                  floor: this.model.floor,
                  unit_price: this.model.unit_price,
                  use_status: this.selectSiyou,
                  sex: this.selectSex,
                };
                this.putRequest(
                  this.url.update,
                  params,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        } else {
          this.$refs.confirm
            .open("登録", "部屋マスタを登録します。宜しいですか？", {
              color: "info",
            })
            .then((confirm) => {
              if (confirm) {
                let insertParams = {
                  user_id: this.$store.getters.getUserId,
                  building_id: this.model.building_id,
                  room_id: this.model.room_id,
                  room_class: this.selectRoomClass,
                  unit_price: this.model.unit_price,
                  floor: this.model.floor,
                  use_status: this.selectSiyou,
                  sex: this.selectSex,
                };
                this.postRequest(
                  this.url.add,
                  insertParams,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        }
      }
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.selectSiyou = "";
      this.selectSex = "";
      this.selectRoomClass = "";
      this.dialog = false;
    },
    open() {
      this.dialog = true;
      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 25px !important;
}

.radioTitle {
  padding-top: 0px;
}
</style>
